// ===============================
// Bundle Builder - JS
// ===============================

// Store URL
const STORE_URL = 'https://therangehoodstore.com';

// Category -> collection handle mapping
const CATEGORY_COLLECTIONS = {
  'range': 'zline-ranges',
  'cooktop': 'zline-cooktops',
  'wall-oven': 'zline-wall-ovens',
  'range-hood': 'zline-range-hoods',
  'refrigerator': 'zline-refrigerators',
  'microwave': 'zline-microwaves',
  'dishwasher': 'zline-dishwashers'
};

// Filter configuration for each category
const FILTER_CONFIG = {
  'range': ['Size', 'Fuel Type', 'Finish', 'Accents'],
  'cooktop': ['Size', 'Fuel Type', 'Finish', 'Accents'],
  'wall-oven': ['Finish', 'Accents', 'Number Of Ovens'],
  'range-hood': ['Size', 'Finish', 'Accents', 'CFM', 'Mount Type'],
  'refrigerator': ['Size', 'Type', 'Finish', 'Accents'],
  'microwave': ['Size', 'Finish', 'Accents'],
  'dishwasher': ['Size', 'Finish', 'Accents']
};


// Known tags for categorisation
const TAG_CATEGORIES = {
  'Size': [
    '18 Inch', '24 Inch', '30 Inch', '36 Inch', '48 Inch', '60 Inch'
  ],
  'Fuel Type': [
    'All Gas', 'Dual Fuel', 'Induction',
  ],
  'Type': [
    'Built In Refrigeration', 'Counter Depth', 'Standard Depth', 'Column', 'Beverage Fridge', 'Wine Refrigeration'
  ],
  'Finish': [
    'Stainless Steel',
    'Black Stainless Steel',
    'Satin Stainless Steel',
    'Black Satin Stainless Steel',
    'Wood',
    'Glass',
    'Oil Rubbed Bronze',
    'White',
  ],

  // ✅ NEW: Accents (all categories)
  'Accents': [
    'Polished Gold Accents',
    'Champagne Bronze Accents',
    'Matte Black Accents',
    'Polished Nickel Accents',
    'No Accents'
  ],

  // ✅ NEW: Wall ovens only
  'Number Of Ovens': [
    'Single Oven',
    'Double Oven'
  ],

  // ✅ NEW: Range hoods only
  'CFM': [
    '400 CFM',
    '500 CFM',
    '600 CFM',
    '700 CFM',
    '2000 CFM'
  ],
  'Mount Type': [
    'Wall Mount',
    'Island Mount',
    'Insert',
    'Under Cabinet'
  ]
};

let currentSearch = '';

const DISCOUNTS_ENABLED = false; // TEMP: set true to restore

// State
let selectedProducts = {};
let allProducts = {};
let currentCategory = null;
let filteredProducts = [];
let currentFilters = {};

// ===============================
// Persist / Restore bundle state
// ===============================
const BUNDLE_STORAGE_KEY = 'zline_bundle_builder_state_v1';

function saveBundleState(step) {
  try {
    const payload = {
      step: step || (
        document.querySelector('.review-container')?.style.display === 'grid'
          ? 'review'
          : 'select'
      ),
      selectedProducts
    };
    sessionStorage.setItem(BUNDLE_STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    console.warn('Could not save bundle state', e);
  }
}

function restoreBundleState() {
  try {
    const raw = sessionStorage.getItem(BUNDLE_STORAGE_KEY);
    if (!raw) return;

    const payload = JSON.parse(raw);
    if (!payload || typeof payload !== 'object') return;

    if (payload.selectedProducts) {
      selectedProducts = payload.selectedProducts;

      Object.entries(selectedProducts).forEach(([category, product]) => {
        if (product) updateApplianceSlot(category, product);
      });

      updateBundleSummary();
    }

    if (payload.step === 'review') {
      showReviewPage();
    } else {
      showSelectionPage();
    }
  } catch (e) {
    console.warn('Could not restore bundle state', e);
  }
}

// ===============================
// Init
// ===============================
document.addEventListener('DOMContentLoaded', () => {
  initializeEventListeners();
  restoreBundleState();
});

window.addEventListener('pageshow', () => {
  restoreBundleState();
});


// ===============================
// Event listeners
// ===============================
function initializeEventListeners() {
  // Appliance slots
  document.querySelectorAll('.appliance-slot').forEach(slot => {
    slot.addEventListener('click', (e) => {
      // Allow clicking "remove" buttons
      if (e.target.closest('.remove-btn')) return;
      const category = slot.getAttribute('data-category');
      openProductModal(category);
    });
  });

  // Modal close
  const modalClose = document.getElementById('modalClose');
  const productModal = document.getElementById('productModal');
  if (modalClose && productModal) {
    modalClose.addEventListener('click', closeProductModal);
    productModal.addEventListener('click', (e) => {
      if (e.target === productModal.querySelector('.modal-overlay')) {
        closeProductModal();
      }
    });
  }

  // Nav buttons
  const reviewBtn = document.getElementById('reviewBtn');
  if (reviewBtn) reviewBtn.addEventListener('click', showReviewPage);

  const backBtn = document.getElementById('backBtn');
  if (backBtn) backBtn.addEventListener('click', showSelectionPage);

  const addToCartBtn = document.getElementById('addToCartBtn');
  if (addToCartBtn) addToCartBtn.addEventListener('click', addBundleToCart);

  // Remove from bundle summary (X button)
  const bundleItemsContainer = document.getElementById('bundleItems');
  if (bundleItemsContainer) {
    bundleItemsContainer.addEventListener('click', function (e) {
      const removeBtn = e.target.closest('.bundle-item-remove');
      if (!removeBtn) return;

      const wrapper = removeBtn.closest('.bundle-item');
      const category = wrapper && wrapper.dataset.category;
      if (!category) return;

      removeProduct(category);
    });
  }
}



// ===============================
// Modal / product loading
// ===============================
async function openProductModal(category) {
  currentCategory = category;

  const modal = document.getElementById('productModal');
  const modalTitle = document.getElementById('modalTitle');
  const productsGrid = document.getElementById('productsGrid');
  const loadingIndicator = document.getElementById('loadingIndicator');
  const filtersContainer = document.getElementById('filters');

  if (!modal || !productsGrid || !loadingIndicator || !filtersContainer) return;

  modalTitle.textContent = `Select ${getCategoryName(category)}`;
  modal.classList.add('active');

  productsGrid.innerHTML = '';
  filtersContainer.innerHTML = '';
  loadingIndicator.style.display = 'block';

  // Load products if not already loaded
  if (!allProducts[category]) {
    await loadProducts(category);
  }

  // Setup filters
  setupFilters(category);

  // Wire up search (reset + listen)
  const searchInput = document.getElementById('productSearch');
  if (searchInput) {
    searchInput.value = '';
    searchInput.oninput = applyFilters; // prevents stacking duplicate listeners
  }

  // Show all products initially
  filteredProducts = allProducts[category] || [];
  displayProducts(filteredProducts);

  loadingIndicator.style.display = 'none';
}

async function loadProducts(category) {
  const handle = CATEGORY_COLLECTIONS[category];
  if (!handle) return;

  try {
    let page = 1;
    let all = [];
    const limit = 250;
    const MAX_PAGES = 10;

    while (page <= MAX_PAGES) {
      const url = `${STORE_URL}/collections/${handle}/products.json?limit=${limit}&page=${page}`;
      const response = await fetch(url);
      const data = await response.json();

      const batch = data.products || [];
      all = all.concat(batch);

      if (batch.length < limit) break;
      page++;
    }

    allProducts[category] = all
      .map(product => {
        let tags = product.tags;
        if (typeof tags === 'string') {
          tags = tags.split(',').map(t => t.trim());
        }

        return {
          productId: product.id,
          title: product.title,
          image: (product.images[0] && product.images[0].src) || '',
          tags: tags || [],
          handle: product.handle,
          vendor: product.vendor,
          variants: (product.variants || []).map(v => ({
            id: v.id,
            price: v.price,
            compare_at_price: v.compare_at_price,  // ✅ add this
            sku: v.sku,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
            available: v.available
          }))

        };
      })
      // ✅ keep only products that actually have variants
      .filter(p => p.variants && p.variants.length);

    console.log(`Loaded ${allProducts[category].length} products for ${category}`);
  } catch (err) {
    console.error(`Error loading products for ${category}`, err);
    allProducts[category] = [];
  }
}

// ===============================
// Filters
// ===============================

// Map a single tag to a high-level filter type
function categorizeTag(tag) {
  const clean = tag.trim().toLowerCase();

  // --- Special handling for Fuel Type ---
  if (clean.includes('all gas') || clean === 'gas') {
    return 'Fuel Type';
  }
  if (clean.includes('dual fuel')) {
    return 'Fuel Type';
  }
  // Treat anything mentioning "induction" or "electric" as induction fuel type
  if (clean.includes('induction') || clean.includes('electric')) {
    return 'Fuel Type';
  }
  // -------------------------------------

  // Generic handling for Size / Type / Finish etc. using TAG_CATEGORIES
  for (const [filterType, values] of Object.entries(TAG_CATEGORIES)) {
    if (values.some(v => clean.includes(v.toLowerCase()))) {
      return filterType;
    }
  }
  return null;
}
// Work out a canonical Fuel Type for a product based on tags
function getProductFuelType(product) {
  let tags = product.tags;

  if (typeof tags === 'string') {
    tags = tags.split(',').map(t => t.trim());
  }
  if (!tags || !Array.isArray(tags)) return null;

  const lowerTags = tags.map(t => t.toLowerCase());

  // Order matters: check dual fuel first
  if (lowerTags.some(t => t.includes('dual fuel'))) {
    return 'Dual Fuel';
  }

  // All-gas / gas
  if (lowerTags.some(t => t.includes('all gas') || t === 'gas')) {
    return 'All Gas';
  }

  // Treat anything mentioning induction / all electric / electric as Induction
  if (
    lowerTags.some(
      t =>
        t.includes('induction') ||
        t.includes('all electric') ||
        t.includes('electric')
    )
  ) {
    return 'Induction';
  }

  return null;
}

// Work out a canonical finish for a product, ignoring *Door tags
function getProductFinish(product) {
  let tags = product.tags;

  if (typeof tags === 'string') {
    tags = tags.split(',').map(t => t.trim());
  }
  if (!tags || !Array.isArray(tags)) return null;

  const lowerTags = tags
    .map(t => t.toLowerCase())
    .filter(t => !t.includes('door')); // keep ignoring Door tags

  const has = (needle) => lowerTags.some(t => t === needle || t.includes(needle));

  // Most specific first
  if (has('black satin stainless steel')) return 'Black Satin Stainless Steel';
  if (has('black stainless steel'))       return 'Black Stainless Steel';
  if (has('satin stainless steel'))       return 'Satin Stainless Steel';
  if (has('stainless steel'))             return 'Stainless Steel';

  // Add your Range Hood finishes
  if (has('oil rubbed bronze'))           return 'Oil Rubbed Bronze';
  if (has('copper'))                      return 'Copper';
  if (has('glass'))                       return 'Glass';
  if (has('wood'))                        return 'Wood';
  if (has('white'))                       return 'White';

  return null;
}
function getProductAccent(product) {
  let tags = product.tags;

  if (typeof tags === 'string') {
    tags = tags.split(',').map(t => t.trim());
  }
  if (!tags || !Array.isArray(tags)) return 'No Accents';

  const lowerTags = tags.map(t => t.toLowerCase());

  if (lowerTags.some(t => t.includes('polished gold'))) {
    return 'Polished Gold Accents';
  }
  if (lowerTags.some(t => t.includes('champagne bronze'))) {
    return 'Champagne Bronze Accents';
  }
  if (lowerTags.some(t => t.includes('matte black'))) {
    return 'Matte Black Accents';
  }
  if (lowerTags.some(t => t.includes('polished nickel'))) {
    return 'Polished Nickel Accents';
  }

  // ✅ KEY LINE
  return 'No Accents';
}

// Build the list of values for each filter dropdown
function getFilterValues(products, filterType) {
// ----- Special case: Fuel Type (canonical options) -----
if (filterType === 'Fuel Type') {
  const present = new Set();

  products.forEach(p => {
    const fuel = getProductFuelType(p);
    if (fuel) {
      present.add(fuel);
    }
  });

  const result = Array.from(present);
  console.log('Filter values for Fuel Type:', result);
  return result;
}
// ----- Special case: Accents -----
if (filterType === 'Accents') {
  const allowed = TAG_CATEGORIES.Accents || [];
  const present = new Set();

  products.forEach(p => {
    const accent = getProductAccent(p);
    if (accent && allowed.includes(accent)) {
      present.add(accent);
    }
  });

  const result = Array.from(present);
  console.log('Filter values for Accents:', result);
  return result;
}

  // ----- Special case: Finish (only the 4 curated values, no *Door) -----
  if (filterType === 'Finish') {
    const allowed = TAG_CATEGORIES.Finish || [];
    const present = new Set();

    products.forEach(p => {
      const finish = getProductFinish(p);
      if (finish && allowed.includes(finish)) {
        present.add(finish);
      }
    });

    const result = Array.from(present);
    console.log(`Filter values for ${filterType}:`, result);
    return result;
  }

  // ----- Generic behaviour for Size / Type, etc. -----
  const values = new Set();

  products.forEach(product => {
    let tags = product.tags;

    if (typeof tags === 'string') {
      tags = tags.split(',').map(tag => tag.trim());
    }
    if (!tags || !Array.isArray(tags)) return;

    tags.forEach(tag => {
      const tagCategory = categorizeTag(tag);
      if (tagCategory === filterType) {
        values.add(tag.trim());
      }
    });
  });

  const result = Array.from(values).sort();
  console.log(`Filter values for ${filterType}:`, result);
  return result;
}

// Create the filter dropdowns for the current category
function setupFilters(category) {
  const filtersContainer = document.getElementById('filters');
  if (!filtersContainer) return;

  const filterTypes = FILTER_CONFIG[category] || [];
  filtersContainer.innerHTML = '';

  const products = allProducts[category] || [];

  filterTypes.forEach(type => {
    const values = getFilterValues(products, type);
    if (!values.length) return;

    const group = document.createElement('div');
    group.className = 'filter-group';

    const label = document.createElement('label');
    label.textContent = type;

    const select = document.createElement('select');
    select.dataset.filterType = type;

    const defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = type;
    select.appendChild(defaultOpt);

    values.forEach(v => {
      const opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      select.appendChild(opt);
    });

    select.addEventListener('change', applyFilters);

    group.appendChild(label);
    group.appendChild(select);
    filtersContainer.appendChild(group);
  });
}

function applyFilters() {
  const products = allProducts[currentCategory] || [];
  const filters = {};

  // Grab dropdown filters
  document.querySelectorAll('#filters select').forEach(sel => {
    if (sel.value) filters[sel.dataset.filterType] = sel.value;
  });

  // Grab search text (name OR SKU)
  const searchEl = document.getElementById('productSearch');
  const searchTerm = (searchEl?.value || '').trim().toLowerCase();

  currentFilters = { ...filters, _search: searchTerm };

  // No filters & no search → show everything
  if (!Object.keys(filters).length && !searchTerm) {
    filteredProducts = products;
    displayProducts(filteredProducts);
    return;
  }

  filteredProducts = products.filter(product => {

  // 🔍 SEARCH MATCH (title OR any variant SKU)
  if (searchTerm) {
    const titleMatch = (product.title || '')
      .toLowerCase()
      .includes(searchTerm);

    const skuMatch = (product.variants || []).some(v =>
      (v.sku || '').toLowerCase().includes(searchTerm)
    );

    if (!titleMatch && !skuMatch) return false;
  }

  // ✅ Existing dropdown filter logic
  return Object.entries(filters).every(([filterType, filterValue]) => {

    if (filterType === 'Fuel Type') {
      const productFuel = getProductFuelType(product);
      return productFuel &&
        productFuel.toLowerCase() === filterValue.toLowerCase();
    }

    if (filterType === 'Finish') {
      const productFinish = getProductFinish(product);
      return productFinish &&
        productFinish.toLowerCase() === filterValue.toLowerCase();
    }

    if (filterType === 'Accents') {
      const productAccent = getProductAccent(product);
      return productAccent &&
        productAccent.toLowerCase() === filterValue.toLowerCase();
    }

    let tags = product.tags;
    if (typeof tags === 'string') tags = tags.split(',').map(t => t.trim());
    if (!Array.isArray(tags)) return false;

    const valueLower = filterValue.toLowerCase();
    return tags.some(tag =>
      tag.toLowerCase().includes(valueLower)
    );
  });
});

  displayProducts(filteredProducts);
}

function normalizeSizeValue(v) {
  if (!v) return '';
  // "36 Inch" -> "36"
  const m = String(v).match(/\d+/);
  return m ? m[0] : String(v).toLowerCase();
}

function getMatchingVariant(product, filters) {
  const variants = product.variants || [];
  if (!variants.length) return null;

  const sizeFilter = filters && filters['Size'] ? normalizeSizeValue(filters['Size']) : null;

  // If no size filter selected, just return first available variant
  if (!sizeFilter) {
    return variants.find(v => v.available) || variants[0];
  }

  // Try to find a variant whose option value contains the size number
  const match = variants.find(v => {
    const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(String);
    return opts.some(o => normalizeSizeValue(o) === sizeFilter);
  });

  return match || (variants.find(v => v.available) || variants[0]);
}


// ===============================
// Display products
// ===============================
function displayProducts(products) {
  const productsGrid = document.getElementById('productsGrid');
  if (!productsGrid) return;

  productsGrid.innerHTML = '';

  if (!products.length) {
    productsGrid.innerHTML = `
      <p style="grid-column:1/-1;text-align:center;padding:40px;color:#999;">
        No products match your filters
      </p>`;
    return;
  }

  products.forEach(product => {
    const chosenVariant =
      getMatchingVariant(product, currentFilters) ||
      product.variants.find(v => v.available) ||
      product.variants[0];


     const price = chosenVariant
      ? parseFloat(chosenVariant.price).toFixed(2)
      : '0.00';

    const sku = chosenVariant && chosenVariant.sku
      ? chosenVariant.sku
      : '';


    const card = document.createElement('div');
    card.className = 'product-card';

    card.innerHTML = `
      <img class="product-image"
          src="${product.image}"
          alt="${product.title}"
          onerror="this.src='https://via.placeholder.com/250x200?text=No+Image'">

      <div class="product-title">${product.title}</div>

      <div class="product-price">$${price}</div>
      ${sku ? `<div class="product-sku">${sku}</div>` : ``}
    `;


    card.addEventListener('click', () => selectProduct(product, chosenVariant));
    productsGrid.appendChild(card);
  });
}

// ===============================
// Selection & summary
// ===============================
function selectProduct(product, variant) {
  const chosenVariant = variant || getMatchingVariant(product, currentFilters);

  selectedProducts[currentCategory] = {
    title: product.title,
    image: product.image,
    tags: product.tags,
    handle: product.handle,
    vendor: product.vendor,

    // the critical part:
    id: chosenVariant ? chosenVariant.id : null,
    price: chosenVariant ? chosenVariant.price : "0.00",
    sku: chosenVariant ? chosenVariant.sku : null,

    // optional: keep for debugging
    selectedSize: currentFilters['Size'] || null
  };

  updateApplianceSlot(currentCategory, selectedProducts[currentCategory]);
  updateBundleSummary();
  closeProductModal();
  saveBundleState('select');
}


function updateApplianceSlot(category, product) {
  const slot = document.querySelector(`.appliance-slot[data-category="${category}"]`);
  if (!slot) return;

  slot.classList.add('selected');

  // Remove old content (image + name) if present
  slot.querySelectorAll('.selected-product-image, .selected-product-name').forEach(el => el.remove());

  const img = document.createElement('img');
  img.src = product.image;
  img.className = 'selected-product-image';
  img.alt = product.title;
  img.onerror = function () {
    this.src = 'https://via.placeholder.com/150?text=No+Image';
  };

  const name = document.createElement('div');
  name.className = 'selected-product-name';
  name.textContent = product.title;

  const icon = slot.querySelector('.appliance-icon');
  if (icon) {
    icon.insertAdjacentElement('afterend', img);
    img.insertAdjacentElement('afterend', name);
  } else {
    slot.insertBefore(img, slot.firstChild);
    slot.insertBefore(name, img.nextSibling);
  }

  // Hide default text
  const h3 = slot.querySelector('h3');
  const p = slot.querySelector('p');
  if (h3) h3.style.display = 'none';
  if (p) p.style.display = 'none';
}

function removeProduct(category) {
  delete selectedProducts[category];
  const slot = document.querySelector(`.appliance-slot[data-category="${category}"]`);
  if (!slot) return;

  slot.classList.remove('selected');
  slot.querySelectorAll('.selected-product-image, .selected-product-name').forEach(el => el.remove());

  const h3 = slot.querySelector('h3');
  const p = slot.querySelector('p');
  if (h3) h3.style.display = 'block';
  if (p) p.style.display = 'block';
  saveBundleState('select');


  updateBundleSummary();
}

function updateBundleSummary() {
  const itemsContainer = document.getElementById('bundleItems');
  const products = Object.values(selectedProducts);
  const count = products.length;

  if (!itemsContainer) return;

  if (!count) {
    itemsContainer.innerHTML = `
      <div class="empty-state">
      </div>`;
    const reviewBtn = document.getElementById('reviewBtn');
    if (reviewBtn) reviewBtn.disabled = true;
  } else {
    itemsContainer.innerHTML = products.map(p => {
      const category = findCategoryByProduct(p);

      // Safely get title + SKU
      const title = p.title || "";
      const sku = p.sku || p.id || "";

      const titleRaw = (p.title || "").trim();
      const skuRaw   = (p.sku || p.id || "").trim();

      let shortTitle = titleRaw;
      const MAX_TITLE = 70; // adjust if you want shorter/longer
      if (shortTitle.length > MAX_TITLE) {
        shortTitle = shortTitle.substring(0, MAX_TITLE) + "...";
      }

      const displayName = skuRaw ? `${shortTitle} (${skuRaw})` : shortTitle;


      return `
        <div class="bundle-item" data-category="${category}">
          <div class="bundle-item-label">${displayName}</div>
          <span class="bundle-item-price">$${parseFloat(p.price).toFixed(2)}</span>
          <button type="button"
                  class="bundle-item-remove"
                  aria-label="Remove ${getCategoryName(category)} from bundle">
           &times;
          </button>
        </div>
      `;
    }).join('');

    const reviewBtn = document.getElementById('reviewBtn');
    if (reviewBtn) reviewBtn.disabled = false;
  }

  const subtotal = products.reduce((sum, p) => sum + parseFloat(p.price), 0);
  const discountPercent = getDiscountPercent(count);
  const discountAmount = subtotal * (discountPercent / 100);
  const total = subtotal - discountAmount;

  const subtotalEl = document.getElementById('subtotal');
  const discountPercentEl = document.getElementById('discountPercent');
  const discountAmountEl = document.getElementById('discountAmount');
  const finalTotalEl = document.getElementById('finalTotal');

  if (subtotalEl) subtotalEl.textContent = `$${subtotal.toFixed(2)}`;
  if (discountPercentEl) discountPercentEl.textContent = discountPercent;
  if (discountAmountEl) discountAmountEl.textContent = `-$${discountAmount.toFixed(2)}`;
  if (finalTotalEl) finalTotalEl.textContent = `$${total.toFixed(2)}`;

  // Floating summary (bottom-right)
  const floatingWrap = document.getElementById('floatingDiscount');
  const floatingSubtotalEl = document.getElementById('floatingSubtotal');
  const floatingSavingsEl  = document.getElementById('floatingSavings');
  const floatingTotalEl    = document.getElementById('floatingTotal');

  if (floatingWrap && floatingSubtotalEl && floatingSavingsEl && floatingTotalEl) {
   // Show only when there’s at least 1 item selected (change to `count >= 2` if you prefer)
    if (count > 0) {
      floatingSubtotalEl.textContent = `$${subtotal.toFixed(2)}`;
      floatingSavingsEl.textContent  = discountAmount > 0 ? `-$${discountAmount.toFixed(2)}` : `-$0.00`;
      floatingTotalEl.textContent    = `$${total.toFixed(2)}`;
      floatingWrap.style.display = 'block';
    } else {
      floatingWrap.style.display = 'none';
    }
  }
} 

  

function getDiscountPercent(count) {
  if (!DISCOUNTS_ENABLED) return 0;
  if (count >= 5) return 10;
  if (count >= 3) return 7;
  if (count >= 2) return 5;
  return 0;
}


// ===============================
// Review / selection toggle
// ===============================
function showReviewPage() {
  const selection = document.querySelector('.selection-container');
  const review = document.querySelector('.review-container');

  if (selection) selection.style.display = 'none';
  if (review) review.style.display = 'grid';

  const step1 = document.querySelector('.progress-step[data-step="1"]');
  const step2 = document.querySelector('.progress-step[data-step="2"]');
  if (step1) step1.classList.remove('active');
  if (step2) step2.classList.add('active');

  const products = Object.entries(selectedProducts);
  const reviewGrid = document.getElementById('reviewGrid');

  if (reviewGrid) {
    reviewGrid.innerHTML = products.map(([category, product]) => `
      <div class="review-item">
        <img class="review-item-image"
             src="${product.image}"
             alt="${product.title}"
             onerror="this.src='https://via.placeholder.com/110?text=No+Image'">
        <div class="review-item-details">
          <h4>${product.title}</h4>
          <div class="review-item-category">${getCategoryName(category)}</div>
        </div>
        <div class="review-item-price">
          $${parseFloat(product.price).toFixed(2)}
        </div>
      </div>
    `).join('');
    saveBundleState('review');
  }

  const subtotal = products.reduce((sum, [, p]) => sum + parseFloat(p.price), 0);
  const count = products.length;
  const discountPercent = getDiscountPercent(count);
  const discountAmount = subtotal * (discountPercent / 100);
  const total = subtotal - discountAmount;

  const reviewSubtotal = document.getElementById('reviewSubtotal');
  const reviewDiscountPercent = document.getElementById('reviewDiscountPercent');
  const reviewDiscountAmount = document.getElementById('reviewDiscountAmount');
  const reviewTotal = document.getElementById('reviewTotal');

  if (reviewSubtotal) reviewSubtotal.textContent = `$${subtotal.toFixed(2)}`;
  if (reviewDiscountPercent) reviewDiscountPercent.textContent = discountPercent;
  if (reviewDiscountAmount) reviewDiscountAmount.textContent = `-$${discountAmount.toFixed(2)}`;
  if (reviewTotal) reviewTotal.textContent = `$${total.toFixed(2)}`;

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function showSelectionPage() {
  const selection = document.querySelector('.selection-container');
  const review = document.querySelector('.review-container');

  if (selection) selection.style.display = 'block';
  if (review) review.style.display = 'none';

  const step1 = document.querySelector('.progress-step[data-step="1"]');
  const step2 = document.querySelector('.progress-step[data-step="2"]');
  if (step1) step1.classList.add('active');
  if (step2) step2.classList.remove('active');

  window.scrollTo({ top: 0, behavior: 'smooth' });
  saveBundleState('select');
}

// ===============================
// Add bundle to cart + discounts
// ===============================
async function addBundleToCart() {
  const button = document.getElementById('addToCartBtn');
  if (!button) return;

  const products = Object.values(selectedProducts);
  const count = products.length;

  if (!count) {
    alert('Please select at least one product.');
    return;
  }

  button.textContent = 'Adding to Cart...';
  button.disabled = true;

  try {
    // Tiered discount codes (only if enabled)
    let discountCode = null;

    if (DISCOUNTS_ENABLED) {
      if (count === 2) {
        discountCode = 'BUNDLE5';
      } else if (count >= 3 && count <= 4) {
        discountCode = 'BUNDLE7';
      } else if (count >= 5) {
        discountCode = 'BUNDLEBUILDER10';
      }
    }

    const items = products.map(p => ({
      id: p.id,
      quantity: 1
    }));

    const response = await fetch(`${STORE_URL}/cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const text = await response.text();
      console.error('Cart add failed:', response.status, text);
      throw new Error('Failed to add to cart');
    }

    saveBundleState('review');

    if (discountCode) {
      window.location.href = `/discount/${discountCode}?redirect=/cart`;
    } else {
      window.location.href = '/cart';
    }

  } catch (err) {
    console.error('Error adding bundle to cart', err);
    alert('There was an error adding items to your cart. Please try again.');
    button.textContent = 'Add Bundle to Cart';
    button.disabled = false;
  }
}


// ===============================
// Helpers
// ===============================
function closeProductModal() {
  const modal = document.getElementById('productModal');
  if (modal) modal.classList.remove('active');
}

function getCategoryName(category) {
  if (!category) return '';
  return category.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

function findCategoryByProduct(product) {
  for (const [category, prod] of Object.entries(selectedProducts)) {
    if (prod.id === product.id) return category;
  }
  return null;
}
